import common from './common.json';
import meta from './meta.json';
import nav from './nav.json';
import pages from './pages.json';
import home from './home.json';
import schedule from './schedule.json';
import venues from './venues.json';
import story from './story.json';
import rsvp from './rsvp.json';

export default {
  ...common,
  ...meta,
  ...nav,
  ...pages,
  ...home,
  ...schedule,
  ...venues,
  ...story,
  ...rsvp,
};
